import PostPageHeaderHtml from "./PostPageHeaderHtml.js";
import SignInSectionCmp from "../../../components/page-header/SignInSectionCmp.js";
import BreadcrumbsHeaderCmp from "../../../components/page-header/BreadcrumbsHeaderCmp.js";

export default class PostPageHeaderCmp {
    #html = new PostPageHeaderHtml();
    /** @type {SignInSectionCmp} */
    #singInSectionCmp = new SignInSectionCmp();
    /** @type {UserHeaderCmp} */
    #userHeaderCmp;
    /** @type {BreadcrumbsHeaderCmp} */
    #breadcrumbsCmp = new BreadcrumbsHeaderCmp();

    /** @param {UserHeaderCmp} userHeaderCmp */
    constructor(userHeaderCmp) {
        this.#userHeaderCmp = userHeaderCmp;
    }

    init(pageHeaderEl) {
        this.#html.init(pageHeaderEl);
        this.#singInSectionCmp.init(this.#html.getUserHeaderElement());
        this.#userHeaderCmp.init(this.#html.getUserHeaderElement());
        this.#breadcrumbsCmp.init(this.#html.getBreadcrumbsElement());
    }

    /**
     * @param {SecurityContext} securityContext
     */
    setSecurityContext(securityContext) {
        this.#singInSectionCmp.setSecurityContext(securityContext);
        if (securityContext.isAuthenticated())
            this.#userHeaderCmp.show(securityContext.getCurrentUser());
    }

    /** @param {Post} post */
    fillBreadcrumbs(post){
        this.#breadcrumbsCmp.addPostTitle(post)
    }

    /** @param {function} callback */
    onSharePostClick(callback) {
        this.#breadcrumbsCmp.onSharePostClick(callback);
    }

    /** @param {function} callback */
    onDeletePostClick(callback) {
        this.#breadcrumbsCmp.onDeletePostClick(callback);
    }
}